import { render, staticRenderFns } from "./CreateForm - 副本 (2).vue?vue&type=template&id=00d1e330&scoped=true"
import script from "./CreateForm - 副本 (2).vue?vue&type=script&lang=js"
export * from "./CreateForm - 副本 (2).vue?vue&type=script&lang=js"
import style0 from "./CreateForm - 副本 (2).vue?vue&type=style&index=0&id=00d1e330&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1e330",
  null
  
)

export default component.exports